import backgroundRed from "@/assets/background_red.svg";
import decoratorGreen from "@/assets/decorator_green.svg";
import AuthCard from "@/components/AuthCard";

export default function Confirmed() {
  return (
    <AuthCard
      title="Inscripción confirmada"
      subtitle={
        <strong className="font-semibold text-ink">
          Tu asistencia al curso ha sido confirmada. ¡Te esperamos!
        </strong>
      }
      background={backgroundRed}
      decorator={decoratorGreen}
    >
      {null}
    </AuthCard>
  );
}
